import styled from 'styled-components';

export default styled.a`
  font-family: 'Ubuntu';
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  color: #fff;
`;